<template>
  <div class="absolute right-4 top-[50%]" style="transform: translateY(-50%)">
    <i class="animate-spin fa-solid fa-spinner-third text-neutral600 text-xl" />
  </div>
</template>
